import { Injectable, Injector, OnInit } from '@angular/core';

import { isEmpty } from 'lodash';

@Injectable()
export class LinkExpirationServie {
	CurrentDate: any;
	constructor() {}

	setLinkExpiration(reQuoteData) {
		if (!isEmpty(reQuoteData)) {
			if (!reQuoteData.RemainingTimeForTokenSet) {
				reQuoteData.RemainingTimeForTokenSet = true;
				if (reQuoteData.RemainingTimeForToken != null) {
					reQuoteData.expiredForToken = new Date(new Date().getTime() + reQuoteData.RemainingTimeForToken * 60 * 1000);
				}
			}
		}
	}

	validateLinkExpiration(ajaxInfo, reQuoteData) {
		let result = true;
		this.CurrentDate = new Date();
		if (!isEmpty(reQuoteData)) {
			if (
				reQuoteData.expiredForToken - this.CurrentDate <= 0 ||
				(reQuoteData.HasAlreadyBridged && reQuoteData.IsOneTimeBridge)
			) {
				result = false;
				ajaxInfo.action = reQuoteData.ActionToRun;
			}

			reQuoteData.HasAlreadyBridged = true;
		}

		return result;
	}
}
